/* CHB header behaviours. Single re-runnable initializer; guards against double-binding. */
window.CHBHeader = (function () {
  function initSearchToggle() {
    var toggle = document.querySelector('.chb-search-toggle');
    if (!toggle || toggle.dataset.chbBound) return;
    toggle.dataset.chbBound = '1';
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('chb-search-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = document.querySelector('.chb-searchbar__input');
        if (input) input.focus();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('chb-search-open')) {
        document.body.classList.remove('chb-search-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initMegaHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var lis = document.querySelectorAll('.chb-nav__list > li');
    var closeTimer;
    var closeAll = function (except) {
      document.querySelectorAll('.chb-nav details[open]').forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    };
    lis.forEach(function (li) {
      var details = li.querySelector('header-menu > details');
      if (!details || details.dataset.chbBound) return;
      details.dataset.chbBound = '1';
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAll(details);
        details.setAttribute('open', '');
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { details.removeAttribute('open'); }, 220);
      });
      var summary = details.querySelector('summary');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(closeTimer);
        if (details.hasAttribute('open')) details.removeAttribute('open');
        else { closeAll(details); details.setAttribute('open', ''); }
      });
    });
    if (!document.body.dataset.chbMegaEsc) {
      document.body.dataset.chbMegaEsc = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll(null);
      });
    }
  }

  function initRails() {
    document.querySelectorAll('.chb-rail').forEach(function (rail) {
      if (rail.dataset.chbBound) return;
      rail.dataset.chbBound = '1';
      var items = rail.querySelectorAll('[data-chb-pane-target]');
      var panes = rail.querySelectorAll('[data-chb-pane]');
      var show = function (id) {
        panes.forEach(function (p) { p.hidden = p.id !== id; });
        items.forEach(function (b) {
          b.setAttribute('aria-expanded', b.getAttribute('data-chb-pane-target') === id ? 'true' : 'false');
        });
      };
      items.forEach(function (btn) {
        var id = btn.getAttribute('data-chb-pane-target');
        btn.addEventListener('mouseenter', function () { show(id); });
        btn.addEventListener('focus', function () { show(id); });
        btn.addEventListener('click', function () { show(id); });
      });
    });
  }

  // Zone B rail → Zone C flyout inside a pane (Rail → Rail → cards in a flyout).
  function initCascades() {
    document.querySelectorAll('[data-chb-cascade]').forEach(function (casc) {
      if (casc.dataset.chbBound) return;
      casc.dataset.chbBound = '1';
      var items = casc.querySelectorAll('[data-chb-sub-target]');
      var panes = casc.querySelectorAll('[data-chb-sub-pane]');
      if (!items.length || !panes.length) return;
      var show = function (id) {
        panes.forEach(function (p) { p.hidden = p.id !== id; });
        items.forEach(function (b) {
          b.setAttribute('aria-expanded', b.getAttribute('data-chb-sub-target') === id ? 'true' : 'false');
        });
      };
      items.forEach(function (btn) {
        var id = btn.getAttribute('data-chb-sub-target');
        btn.addEventListener('mouseenter', function () { show(id); });
        btn.addEventListener('focus', function () { show(id); });
        btn.addEventListener('click', function (e) { e.preventDefault(); show(id); });
      });
    });
  }

  function initDrawerAccordions() {
    var nav = document.querySelector('.chb-drawer');
    if (!nav || nav.dataset.chbBound) return;
    nav.dataset.chbBound = '1';
    // Capture-phase guard: stop Dawn's MenuDrawer summary handler from running on
    // CHB accordion summaries (its submenu logic assumes stock drawer markup).
    // Native <details> toggling still happens (default action is not cancelled).
    nav.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('summary.chb-drawer__summary')) e.stopPropagation();
      },
      true
    );
    // Keep aria-expanded in sync with each accordion's real state.
    nav.querySelectorAll('details.chb-drawer__acc').forEach(function (d) {
      var summary = d.querySelector(':scope > summary.chb-drawer__summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
      d.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      });
    });
  }

  function init() {
    if (!document.querySelector('.header--chb')) return;
    initSearchToggle();
    initMegaHover();
    initRails();
    initCascades();
    initDrawerAccordions();
  }

  if (window.Shopify && window.Shopify.designMode) {
    // Pop the containing mega panel open while a block inside it (e.g. a
    // chb_promo card) is selected in the theme editor, so merchants can see
    // what they're editing; close it again on deselect.
    document.addEventListener('shopify:block:select', function (e) {
      var details = e.target.closest('details.chb-mega');
      if (!details) return;
      details.setAttribute('open', '');
      var pane = e.target.closest('[data-chb-pane]');
      if (pane) {
        var rail = pane.closest('.chb-rail');
        if (rail) {
          rail.querySelectorAll('[data-chb-pane]').forEach(function (p) {
            p.hidden = p !== pane;
          });
          rail.querySelectorAll('[data-chb-pane-target]').forEach(function (b) {
            b.setAttribute('aria-expanded', b.getAttribute('data-chb-pane-target') === pane.id ? 'true' : 'false');
          });
        }
      }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var details = e.target.closest ? e.target.closest('details.chb-mega') : null;
      if (details) details.removeAttribute('open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  return { init: init };
})();
